import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, submissionViewModel, StateUtils, ViewModelService, LoadSaveService) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;

    ctrl.init = function () {
        $scope.submissionVM = submissionVM;
        $scope.msfEntitytypeDefined = true;
        $scope.activeView = 'default';
    };

    ctrl.changeView = function (changeView) {
        $scope.activeView = changeView;
        if (changeView === 'addAdditionalNamedInsured') $scope.editAdditionalInsuredIndex = null;
    };
    /**
     * Resets the active view to the default view
     */
    ctrl.cancelAction = function () {
        $scope.activeView = 'default';
    };

    /**
     * Update policy Address
     */
    ctrl.changePolicyAddress = function (policyAddress) {
        $scope.submissionVM.baseData.policyAddress = policyAddress;
        $scope.activeView = 'default';
    };
    /**
     * Update Named Insured
     */
    ctrl.changeNamedInsured = function (data) {

        $scope.submissionVM.baseData.mSFPrimaryInsuredContact_EXT = data;
        $scope.submissionVM.baseData.policyAddress = data.primaryAddress;

        /**
         * updating to PC
         */
        LoadSaveService.saveSubmission($scope.submissionVM.value);

        $scope.activeView = 'default';
    };
    /**
     * Change Named Insured View 
     */
    ctrl.changeNamedInsuredView = function (index) {
        $scope.activeView = 'editAdditionalNamedInsured';
        $scope.editAdditionalInsuredIndex = index;
    };
    /**
     * Add New Additional Named Insured
     */
    ctrl.changeAdditionalNamedInsured = function (data) {
        if (angular.isUndefined($scope.submissionVM.baseData.additionalNamedInsured)) $scope.submissionVM.baseData.additionalNamedInsured = [];
        if (data.namedInsuredIndex != null) $scope.submissionVM.baseData.additionalNamedInsured[data.namedInsuredIndex] = data.namedInsuredData;else $scope.submissionVM.baseData.additionalNamedInsured.push(data.namedInsuredData);
        $scope.activeView = 'default';
    };

    ctrl.next = function (nextFn, form) {
        if (angular.isUndefined($scope.submissionVM.value.baseData.mSFPrimaryInsuredContact_EXT.mSFEntityType_EXT) || $scope.submissionVM.value.baseData.mSFPrimaryInsuredContact_EXT.mSFEntityType_EXT == null || $scope.submissionVM.value.baseData.mSFPrimaryInsuredContact_EXT.mSFEntityType_EXT == '') {
            $scope.msfEntitytypeDefined = false;
            form.valid = false;
        }
        if (form.valid) {
            submissionVM.baseData.mSFNamedInsuredVal_EXT.value = true; //Added for Quote Continue Refer FlowConfig.js
        }
        nextFn(submissionVM, form.valid);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'submissionViewModel', 'StateUtils', 'ViewModelService', 'qnb.LoadSaveService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCNamedInsuredCtrl.js
// module id = 1297
// module chunks = 0